import { useEffect, useState } from 'react';

/**
 * Re-renders on an interval so relative timestamps ("4 minutes ago") stay
 * honest between data fetches.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
